enum ERROR_TYPES {
  TECHNICAL_ERROR = 'technicalError',
  NOT_FOUND_ERROR = 'notFound',
  ACCESS_DENIED_ERROR = 'deniedAccess',
  MAINTENANCE_ERROR = 'maintenanceError',
  PARTIAL_MAINTENANCE_ERROR = 'partialMaintenanceError',
}
export default ERROR_TYPES
